const model = {
  submiting: false,
  submitted: false,
  projects: []
}

export default model;
